import React from "react";
import * as properties from '../../elementsPropertiesItems';
// import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';

const FontWeight = (props)=>{
    const {path,keyParam,elementData} = props;
    let fontWeightValue = isSet(elementData,null)!==null?isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'normal':'normal';

    const changeHandler = (e) => {
        const {value} = e.target;        
        props.changeHandler(path,keyParam,value)
    }

    return(
        <div className="w-100">
     		<select className="form-control input-border-bottom1" onChange={e=>changeHandler(e)}>
                {
                    properties.FontWeightTypes.map((item,ind)=>{
                        let isSelected = '';
                        if(item.value === fontWeightValue){
                           isSelected = 'selected';
                        }
                        return(
                            <option selected={isSelected} value={item.value}> {item.label} </option>    
                        )
                    })
                }        		
     		</select>
  		</div>
    )
}

FontWeight.defaultProps = {
    fontWeightValue: 'normal',    
};

export default FontWeight;